module.exports = __webpack_public_path__ + "static/media/previous-arrow-grey.93e7024a.svg";